export default "__VITE_ASSET__ff1e49a9__"